import { Menu } from '@mui/material';

import { MenuOption } from 'src/routes/appSetup/setup/components/app-list/app-list-item/MenuOption';

interface PageTitleMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onRename: () => void;
  onManage: () => void;
  /** Present only for a published app-builder app the viewer may edit. */
  onSwitchToBuilder?: () => void;
}

export const PageTitleMenu = ({
  anchorEl,
  onClose,
  onRename,
  onManage,
  onSwitchToBuilder,
}: PageTitleMenuProps) => (
  <Menu
    open={Boolean(anchorEl)}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    classes={{
      paper:
        'bg-white border border-solid border-secondary-hover shadow-popover-050',
    }}
  >
    {onSwitchToBuilder && (
      // Same entry, icon and position the builder's own live tab offered, so
      // the move out of the builder changes nothing about how to get back.
      <MenuOption
        icon="arrow-right-from-bracket"
        text="Switch to builder"
        onClick={onSwitchToBuilder}
        data-testid="action-Switch to builder"
      />
    )}
    <MenuOption icon="Edit" text="Rename app" onClick={onRename} />
    <MenuOption icon="Settings" text="Manage app" onClick={onManage} />
  </Menu>
);
